import request from '@/utils/request'

export function basicView(params) {
  return request({
    url: '/setting/basic/view',
    method: 'get',
    params
  })
}

export function secureView(params) {
  return request({
    url: '/setting/secure/view',
    method: 'get',
    params
  })
}

export function secureOptions() {
  return request({
    url: '/setting/secure/options',
    method: 'get'
  })
}

export function attachmentOptions() {
  return request({
    url: '/setting/attachment/options',
    method: 'get'
  })
}

export function view(name) {
  return request({
    url: `/setting/view/${name}`,
    method: 'get'
  })
}

export function iotGwView(corp_id) {
  return request({
    url: `/setting/iot-gw/view/${corp_id}`,
    method: 'get'
  })
}

export function bliveGwView(corp_id) {
  return request({
    url: `/setting/blive-gw/view/${corp_id}`,
    method: 'get'
  })
}

export function basicSet(data) {
  return request({
    url: '/setting/basic',
    method: 'post',
    data
  })
}

export function gisSet(data) {
  return request({
    url: '/setting/gis',
    method: 'post',
    data
  })
}

export function attachmentSet(data) {
  return request({
    url: '/setting/attachment',
    method: 'post',
    data
  })
}

export function secureSet(data) {
  return request({
    url: '/setting/secure',
    method: 'post',
    data
  })
}

export function wechatSet(data) {
  return request({
    url: '/setting/wechat',
    method: 'post',
    data
  })
}

export function wechatAppSet(data) {
  return request({
    url: '/setting/wechat_app',
    method: 'post',
    data
  })
}

export function storageSet(data) {
  return request({
    url: '/setting/storage',
    method: 'post',
    data
  })
}

export function cdnSet(data) {
  return request({
    url: '/setting/cdn',
    method: 'post',
    data
  })
}

export function appSet(data) {
  return request({
    url: '/setting/app',
    method: 'post',
    data
  })
}

export function apiSet(data) {
  return request({
    url: '/setting/api',
    method: 'post',
    data
  })
}

export function mailSet(data) {
  return request({
    url: '/setting/mail',
    method: 'post',
    data
  })
}

export function pushSet(data) {
  return request({
    url: '/setting/push',
    method: 'post',
    data
  })
}

export function smsSet(data) {
  return request({
    url: '/setting/sms',
    method: 'post',
    data
  })
}

export function sendTestMail(data) {
  return request({
    url: '/setting/sendTestMail',
    method: 'post',
    data
  })
}

export function sendTestPush(data) {
  return request({
    url: '/setting/sendTestPush',
    method: 'post',
    data
  })
}

export function codeUrlSet(data) {
  return request({
    url: '/setting/codeUrl',
    method: 'post',
    data
  })
}

export function warningSet(data) {
  return request({
    url: '/setting/warning',
    method: 'post',
    data
  })
}

export function weatherSet(data) {
  return request({
    url: '/setting/weather',
    method: 'post',
    data
  })
}

export function getLogs(query) {
  return request({
    url: '/setting/logs',
    method: 'get',
    params: query
  })
}

export function getLogModuleOptions() {
  return request({
    url: '/setting/logs/log-module-options',
    method: 'get'
  })
}

export function deleteLog(id) {
  return request({
    url: `/setting/log/delete/${id}`,
    method: 'delete'
  })
}

export function bliveSet(data) {
  return request({
    url: '/setting/blive',
    method: 'post',
    data
  })
}

export function getTplLocationOptions() {
  return request({
    url: '/setting/getTplLocationOptions',
    method: 'get'
  })
}

export function iotGwSet(corp_id, data) {
  return request({
    url: `/setting/iot_gw/${corp_id}`,
    method: 'post',
    data
  })
}

export function bliveGwSet(corp_id, data) {
  return request({
    url: `/setting/blive_gw/${corp_id}`,
    method: 'post',
    data
  })
}
